import React, { useState } from "react";
import { View, Text, Image, TouchableOpacity, TextInput } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../utility/AppColors";
import { AppImages } from "../../utility/AppImages";
import Separator from "../Separator";
import { SwitchCommon } from "../../common/SwitchCommon";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import TicketDetail from "./TicketDetail";
import CretePrivateEventTooltip from "./CretePrivateEventTooltip";

const TicketPriceAndQuantityComponent = ({
  isOpenDuration,
  isQualityOpen,
  setMinAttendees,
  minAttendees,
  maxAttendees,
  setMaxAttendees,
  isOpenTimeLimit,
  setTimeLimit,
  timeLimit,
  setIsOpen,
  setIsOpenQuality,
  setIsOpenDuration,
  setIsOpenTimeLimit,
  ticketRefundTooltip,
  setTicketRefundTooltip,
  ticketPriceTooltip,
  setTicketPriceTooltip,
  ticketQuantityTooltip,
  setTicketQuantityTooltip,
}) => {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [ticketSwitch, setTicketSwitch] = useState(false);

  const timeLimitOptions = [
    { name: "24 hours" },
    { name: "2 days" },
    { name: "3 days" },
    { name: "4 days" },
    { name: "5 days" },
    { name: "6 days" },
    { name: "Week" },
    { name: "8 days" },
    { name: "9 days" },
    { name: "10 days" },
    { name: "11days" },
    { name: "12 days" },
    { name: "13 days" },
    { name: "2 Weeks" },
  ];

  const toggleTimeLimitDropdown = () => {
    setIsOpenTimeLimit(!isOpenDuration);
    setIsOpenDuration(false);
    setIsOpen(false);
    setIsOpenQuality(false);
  };

  const handleTimeLimitClick = (durationValue) => {
    setTimeLimit(durationValue);
    setIsOpenDuration(false);
  };

  return (
    <View
      style={{
        zIndex: isOpenDuration || isQualityOpen ? -1 : 1,
        width:
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? "100%"
            : "125%",
        flexDirection:
          deviceSize === DEVICE_SIZES.XS ||
          deviceSize === DEVICE_SIZES.SM ||
          deviceSize === DEVICE_SIZES.MD ||
          deviceSize === DEVICE_SIZES.LG
            ? "column"
            : "row",
        justifyContent: "space-between",
      }}
    >
      <View
        style={{
          gap: 12,
          width:
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG
              ? "100%"
              : "80%",
        }}
      >
        {/* Ticket Pricing */}
        <View
          style={{
            width:
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "100%"
                : "49%",
          }}
        >
          <View
            style={{
              flexDirection: "row",
              gap: 12,
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
              Ticket Pricing
            </Text>
            <TouchableOpacity
              onPress={() => setTicketPriceTooltip(!ticketPriceTooltip)}
            >
              <Image
                source={AppImages.icInfoCircle}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            {ticketPriceTooltip && (
              <CretePrivateEventTooltip
                heading="Ticket Price"
                content={
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      Set the price for audience members to purchase a ticket.
                      The suggested price is based on streaming costs, but you
                      can adjust it..
                    </Text>
                  </View>
                }
                width={347}
                right={0}
                bottom={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 34
                    : -80
                }
                visible={ticketPriceTooltip}
                setVisible={setTicketPriceTooltip}
              />
            )}
          </View>
          <View style={[styles.leftWrapper, { zIndex: -1 }]}>
            <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>Ticket Price</Text>
            <View
              style={{
                paddingHorizontal: 12,
                borderRadius: 10,
                backgroundColor: AppColors.appGrayColor_1C1C1C,
                flexDirection: "row",
                minHeight: 50,
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  flex: 0.5,
                  alignItems: "center",
                }}
              >
                <Text style={{ ...AppFontStyle.REGULAR_ANYBODY_12 }}>0.50</Text>
                <Text style={{ ...AppFontStyle.REGULAR_ANYBODY_12 }}>$</Text>
              </View>
              <Separator
                color={AppColors.white}
                height={"100%"}
                width="1px"
                marginTop={0}
                marginBottom={0}
                marginHorizontal={12}
              />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  flex: 0.5,
                  alignItems: "center",
                }}
              >
                <Text style={{ ...AppFontStyle.REGULAR_ANYBODY_12 }}>28</Text>

                <View
                  style={{
                    flexDirection: "row",
                    gap: 5,
                    alignItems: "center",
                  }}
                >
                  <Image
                    source={AppImages.icTokenKo}
                    style={{
                      width: 18,
                      height: 18,
                      tintColor: AppColors.purple_453B50,
                    }}
                  />
                  <Text style={{ ...AppFontStyle.REGULAR_ANYBODY_12 }}>
                    tokens
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>

        {/* Ticket quantity */}

        <View>
          <View
            style={{
              flexDirection: "row",
              gap: 12,
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
              Ticket quantity
            </Text>
            <TouchableOpacity
              onPress={() => setTicketQuantityTooltip(!ticketQuantityTooltip)}
            >
              <Image
                source={AppImages.icInfoCircle}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            {ticketQuantityTooltip && (
              <CretePrivateEventTooltip
                heading="Minimum Required Attendees"
                content={
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      If enabled, the event will only go live once the required
                      number of tickets are sold. This helps ensure costs are
                      covered and builds hype. If the minimum is not met by the
                      deadline, both players will have the option to:
                    </Text>{" "}
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ✅ Proceed with the event regardless of the number of
                      tickets sold.
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ❌ Cancel the event (refunds will be issued to ticket
                      holders and both players).
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ⏳ Extend the deadline for ticket sales by 24 hours (this
                      can only be done once).
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      If an extension is chosen and the goal is still not met,
                      the event will be cancelled and refunds will be issued or
                      you can select proceed with the event.
                    </Text>
                  </View>
                }
                width={347}
                right={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 470
                }
                bottom={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 34
                    : -80
                }
                visible={ticketQuantityTooltip}
                setVisible={setTicketQuantityTooltip}
              />
            )}
            <SwitchCommon
              switchState={ticketSwitch}
              setSwitchState={setTicketSwitch}
            />
          </View>
          <View style={[styles.mainInputWrapper, { zIndex: -1 }]}>
            <View style={styles.leftWrapper}>
              <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                Minimum Number of Attendees
              </Text>
              <View style={[styles.inputWrapper]}>
                <TextInput
                  placeholder={"0"}
                  multiline={false}
                  placeholderTextColor={AppColors.gray_C4C4C4}
                  style={[
                    AppFontStyle.REGULAR_ANYBODY_12,
                    styles.textInputStyle,
                  ]}
                  onSubmitEditing={() => {}}
                  onChangeText={(text) => {
                    const numericText = text.replace(/[^0-9]/g, "");
                    setMinAttendees(numericText);
                  }}
                  keyboardType="numeric"
                  secureTextEntry={false}
                  value={minAttendees}
                />
              </View>
            </View>
            {ticketSwitch && (
              <View style={styles.leftWrapper}>
                <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                  Maximum Number of Attendees
                </Text>
                <View style={[styles.inputWrapper]}>
                  <TextInput
                    placeholder={"300"}
                    multiline={false}
                    placeholderTextColor={AppColors.gray_C4C4C4}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      styles.textInputStyle,
                    ]}
                    onSubmitEditing={() => {}}
                    onChangeText={(text) => {
                      const numericText = text.replace(/[^0-9]/g, "");
                      setMaxAttendees(numericText);
                    }}
                    keyboardType="numeric"
                    secureTextEntry={false}
                    value={maxAttendees}
                  />
                </View>
              </View>
            )}
          </View>

          {ticketSwitch && (
            <View
              style={[
                styles.leftWrapper,
                {
                  marginTop: 12,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "100%"
                      : "49%",
                },
              ]}
            >
              <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                Time limit for ticket sales{" "}
              </Text>
              <View style={{ position: "relative", zIndex: 999 }}>
                <TouchableOpacity onPress={toggleTimeLimitDropdown}>
                  <View style={styles.dropdownButtonStyle}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        styles.dropdownButtonTxtStyle,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      {timeLimit || "Select Time"}
                    </Text>
                    <Icon
                      name={isOpenTimeLimit ? "chevron-up" : "chevron-down"}
                      style={styles.dropdownButtonArrowStyle}
                    />
                  </View>
                </TouchableOpacity>

                {isOpenTimeLimit && (
                  <View
                    style={{
                      position: "absolute",
                      left: 0,
                      width: "100%",
                      top: 50,
                      borderWidth: 1,
                      borderColor: AppColors.white,
                      borderRadius: 10,
                      marginTop: 2,
                      backgroundColor: AppColors.black_121212,
                      zIndex: 1000,
                      elevation: 10,
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.2,
                      shadowRadius: 4,
                    }}
                  >
                    {timeLimitOptions.map((option, idx) => (
                      <TouchableOpacity
                        key={idx}
                        style={{
                          paddingVertical: 10,
                          paddingHorizontal: 12,

                          cursor: "pointer",
                        }}
                        onPress={() => handleTimeLimitClick(option.name)}
                      >
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            {
                              color: AppColors.white,
                              textAlign: "left",
                            },
                          ]}
                        >
                          {option.name}
                        </Text>
                      </TouchableOpacity>
                    ))}
                  </View>
                )}
              </View>
            </View>
          )}
        </View>
        {/* Ticket refund policy  */}
        <View>
          <View
            style={{
              flexDirection: "row",
              gap: 12,
              alignItems: "center",
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.gray_C4C4C4 },
              ]}
            >
              Ticket refund policy
            </Text>
            <TouchableOpacity
              onPress={() => setTicketRefundTooltip(!ticketRefundTooltip)}
            >
              <Image
                source={AppImages.icInfoCircle}
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? 17
                      : 20,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
            {ticketRefundTooltip && (
              <CretePrivateEventTooltip
                heading="Ticket refund policy"
                content={
                  <View>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C4C4C4,
                          lineHeight: 24,
                          paddingBottom: 10,
                        },
                      ]}
                    >
                      If the minimum attendees are not met within the timeframe,
                      the organiser & challenger are notified:
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ✅ They can choose to proceed anyway.
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        { color: AppColors.gray_C4C4C4, lineHeight: 24 },
                      ]}
                    >
                      ❌ If either player declines, the event is cancelled, and
                      all ticket purchasers are refunded.
                    </Text>
                  </View>
                }
                width={347}
                right={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 0
                    : 500
                }
                bottom={
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 34
                    : -34
                }
                visible={ticketRefundTooltip}
                setVisible={setTicketRefundTooltip}
              />
            )}
          </View>
        </View>
      </View>
      <View
        style={{
          width:
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "100%"
              : deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
              ? "49%"
              : "18%",
          gap: 23,
          marginTop:
            deviceSize === DEVICE_SIZES.XS ||
            deviceSize === DEVICE_SIZES.SM ||
            deviceSize === DEVICE_SIZES.MD ||
            deviceSize === DEVICE_SIZES.LG
              ? 12
              : 0,
        }}
      >
        <TicketDetail />
      </View>
    </View>
  );
};

export default TicketPriceAndQuantityComponent;

const useStyles = CreateResponsiveStyle(
  {
    mainInputWrapper: {
      flexDirection: "row",
      gap: 25,
    },
    leftWrapper: {
      flex: 0.5,
      flexDirection: "column",
      gap: 12,
    },
    inputWrapper: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      color: AppColors.white,
      outlineStyle: "none",
    },
    dropdownButtonStyle: {
      width: "100%",
      height: 50,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 12,
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      paddingHorizontal: 12,
    },
    dropdownButtonTxtStyle: {
      flex: 1,
      color: AppColors.white,
    },
    dropdownButtonArrowStyle: {
      fontSize: 28,
      color: AppColors.white,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainInputWrapper: {
        flexDirection: "row",
        gap: 25,
      },
      leftWrapper: {
        flex: 0.5,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.MD]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
    },
    [DEVICE_SIZES.SM]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },
    [DEVICE_SIZES.XS]: {
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      leftWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },
      inputWrapper: {
        flex: 1,
      },
    },
  }
);
